import { Form, Formik } from "formik";
import { MyDialog } from "../../../../components/Dialog";
import * as Yup from "yup";
import ButtonWithLoading from "../../../../components/ButtonWithLoading";
import { getTranslation } from "../../../../heplers/translationHelper";
import { Box, Button, TextField, MenuItem } from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import { useState, useEffect } from "react";
import DeleteDialog from "../../../../components/DeleteDialog";

const shapeCapacities = {
  horizontalRectangle: [2, 4, 6],
  verticalRectangle: [2, 4, 6],
  circle: [4, 6, 8],
};

export const AddNewTable=({open,editTable,onClose,onSubmit,onDelete})=>{
  const [confirmDelete, setConfirmDelete] = useState(false);
  const initialValues= {
      shape:"horizontalRectangle",
      persons:"2",
      reference:""
  }

  


  const validationSchema = Yup.object().shape({
    shape: Yup.string()
        .required(
            getTranslation(
                "Shape is required",
                "Shape is required",
                "Shape is required"
            )
        ),
        persons: Yup.number().min(1,getTranslation("Minimum 1 is required"))
        .required(
            getTranslation(
                "Minimum 1 is required",
                "Minimum 1 is required",
                "Minimum 1 is required"
            )
        ),
});

  return (
    <MyDialog title={editTable?getTranslation("Update table","Update table","Update table"): getTranslation(
      "Create a Table",
      "Create a Table",
      "Create a Table"
      )} open={open} onClose={onClose}>
      <Formik
        initialValues={editTable?editTable:initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values, actions) => onSubmit(values, actions)}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          isSubmitting,
          setFieldValue,
          handleSubmit,
        }) => {
          const availableCapacities =
            shapeCapacities[values.shape] || [];

console.log("jkalshdjkashdlkad",errors)
          return (
            <Form>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "12px",
                  marginTop: "12px",
                  minWidth: "400px",
                }}
              >
                {/* Shape Selector */}
                <TextField
                  label={getTranslation(
                    "Shape",
                    "Shape",
                    "Shape"
                  )}
                  value={values.shape}
                  onChange={(e) => setFieldValue("shape", e.target.value)}
                  select
                  fullWidth
                  error={touched.shape && Boolean(errors.shape)}
                  helperText={touched.shape && errors.shape}
                  variant="outlined"
                >
                  <MenuItem value="horizontalRectangle">{getTranslation("Horizontal rectangle")}</MenuItem>
                  <MenuItem value="verticalRectangle">{getTranslation("Vertical rectangle")}</MenuItem>
                  <MenuItem value="circle">{getTranslation("Circle")}</MenuItem>
                </TextField>

                {/* Persons Capacity Selector */}
                <TextField
               label={getTranslation(
                "Capacity",
                "Capacity",
                "Capacity"
              )}
              value={values.persons}
              
              onChange={(e) => setFieldValue("persons", e.target.value)}
                  select
                  fullWidth
                  error={touched.persons && Boolean(errors.persons)}
                  helperText={touched.persons && errors.persons}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                >
                  {availableCapacities.map((cap) => (
                    <MenuItem key={cap} value={cap}>
                      {cap}
                    </MenuItem>
                  ))}
                </TextField>

                {/* Reference Field */}
                <TextField
                  label={getTranslation("Reference")}
                  value={values.reference}
                  onChange={(e) =>
                    setFieldValue("reference", e.target.value)
                  }
                  fullWidth
                  error={touched.reference && Boolean(errors.reference)}
                  helperText={touched.reference && errors.reference}
                  variant="outlined"
                />
              </Box>

              <Box display="flex" justifyContent="space-between" alignItems="center">
                {/* Submit Button */}
                <ButtonWithLoading
                  loading={isSubmitting}
                  title={editTable?  getTranslation("Update","Update","Update"): getTranslation("Add New","Add New","Add New")}
                  variant="contained"
                  onClick={handleSubmit}
                />
                {editTable && onDelete && (
                  <Button
                    variant="outlined"
                    style={{ color: "#C62828", borderColor: "#C62828" }}
                    startIcon={<DeleteOutline />}
                    onClick={() => setConfirmDelete(true)}
                  >
                    {getTranslation("Delete table", "Supprimer la table", "Tisch löschen")}
                  </Button>
                )}
              </Box>
            </Form>
          );
        }}
      </Formik>
      <DeleteDialog
        open={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        onSubmit={() => {
          setConfirmDelete(false);
          onDelete(editTable);
        }}
      />
    </MyDialog>
  );
};
